<template>
  <div id="categories">
    <v-container>
      <v-row justify="center">
        <v-col md="8">
          <h1>Categories</h1>
          <v-data-table
            :headers="headers"
            :items="categories"
            :page.sync="page"
            :options.sync="options"
            :server-items-length="totalCount"
            :loading="loading"
            :items-per-page="itemsPerPage"
            class="elevation-1"
            hide-default-footer
            @page-count="pageCount = $event"
            @click:row="openDetails"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-dialog
                  v-model="dialog"
                  max-width="300px"
                  v-if="isAuthenticated"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      New Category
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row justify="center">
                          <v-col>
                            <v-text-field
                              v-model="editedItem.name"
                              label="Name"
                              autocomplete="off"
                            ></v-text-field>
                            <v-autocomplete
                              v-model="editedItem.regionID"
                              :loading="regionsLoading"
                              :items="regions"
                              label="Region ID"
                              chips
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">
                        Cancel
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="save">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-text>
                      Are you sure you want to delete this item?
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="deleteItemConfirm"
                      >
                        OK
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }" v-if="isAuthenticated">
              <v-icon class="mr-2" @click.stop.prevent="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon color="red darken-4" @click.stop.prevent="deleteItem(item)"> mdi-delete </v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import apiClient from "@/utils/apiClient";
import { mapGetters } from "vuex";

export default {
  name: "Categories",
  data: () => ({
    totalCount: 0,
    loading: true,
    options: {},
    page: 1,
    pageCount: 0,
    itemsPerPage: 30,
    headers: [
      {
        text: "Name",
        value: "name",
      },
      {
        text: "Region ID",
        value: "regionID",
      },
      {
        text: "Songs Count",
        value: "songsCount",
        sortable: false,
      },
    ],
    categories: [],

    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    editedItem: {
      id: null,
      name: "",
      regionID: "en",
    },
    defaultItem: {
      id: null,
      name: "",
      regionID: "en",
    },
    defaultActionsHeader: {
      text: "Actions",
      value: "actions",
      sortable: false,
    },

    regionsLoading: false,
    regions: [],
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Category" : "Edit Category";
    },
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  mounted() {
    if (this.isAuthenticated) {
      this.headers.push(this.defaultActionsHeader);
    }
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
    dialog(val) {
      if (val && (!Array.isArray(this.regions) || !this.regions.length))
        this.loadRegions();
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    isAuthenticated() {
      this.headers.push(this.defaultActionsHeader);
    },
  },
  methods: {
    loadData() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const options = { page, itemsPerPage, sortBy: sortBy[0] || null, sortDesc: sortDesc[0] || null };
      apiClient
        .getCategories(options)
        .then((response) => {
          this.totalCount = response.data.totalCount;
          this.categories = response.data.items;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    editItem(item) {
      this.editedIndex = this.categories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.categories.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      const { id } = this.editedItem;
      const category = { id };
      apiClient
        .deleteCategory(category)
        .then(() => {
          this.loadData();
        })
        .catch((error) => {
          console.log(error);
        });
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      const { id, name, regionID  } = this.editedItem;
      const category = { id, name, regionID };
      if (this.editedIndex > -1) {
        // Edit
        apiClient
          .updateCategory(category)
          .then(() => {
            this.loadData();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // Create
        apiClient
          .createCategory(category)
          .then(() => {
            this.loadData();
          })
          .catch((error) => {
            console.log(error);
          });
      }
      this.close();
    },

    loadRegions() {
      this.regionsLoading = true
      apiClient
        .getRegions()
        .then((response) => {
          this.regions = response.data.map(x => x.id)
          this.regionsLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.regionsLoading = false
        })
    },

    openDetails(category) {
      this.$router.push({ name: 'category_details', params: { categoryID: category.id } })
    }
  },
};
</script>
